import { render } from "./AftermarketOverviewContainer.vue?vue&type=template&id=61d751f6"
import script from "./AftermarketOverviewContainer.vue?vue&type=script&lang=js"
export * from "./AftermarketOverviewContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__